import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-travel-insurance',
  templateUrl: './travel-insurance.component.html',
  styleUrls: ['./travel-insurance.component.scss']
})
export class TravelInsuranceComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
